var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-scroll-y-reverse-transition',{attrs:{"mode":"out-in"}},[(_vm.ready)?_c('router-view',{attrs:{"active":_vm.active,"installed":_vm.installed,"modal":_vm.modal,"dev":_vm.dev,"ready":_vm.ready}}):_vm._e()],1),_c('update-dialog',{attrs:{"toggle":_vm.updateApp,"forced":_vm.updateForced},on:{"toggle":_vm.onUpdateDialogToggle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }